import React, {Component} from 'react'
import Grid from "../../../Utils/Grid";
import {TableHeaderColumn} from "react-bootstrap-table";
import {standardActions} from "../../../Utils/Grid/StandardActions";
import Link from "react-router-dom/es/Link";
import Card from "Utils/Cards/Card"
import Header from "Utils/Grid/Header";

export default class VehiculosList extends Component{

    componentWillMount() {
        const { listar, page } = this.props;
        listar(page);
    }

    tipoFormat = (cell, row) => {
        return <span>{cell.nombre}</span>
    }
    render() {
        const { listar: onPageChange, onSortChange, eliminar } = this.props;
        const { data, loader, page } = this.props;
        return(
            <div className="mb-4 col-12">
                <Card
                    icon="configuraciones_activo"
                    titulo="VEHÍCULOS"
                    subtitulo="De proveedores">
                    <Header to="vehiculo/crear" textBtn="CREAR VEHÍCULO" {...this.props} />
                    <Grid hover striped data={data} loading={loader} onPageChange={onPageChange}
                          onSortChange={onSortChange} page={page} >
                        <TableHeaderColumn
                            isKey
                            dataField="id"
                            dataAlign="center"
                            dataSort
                            width='20%'
                            dataFormat={standardActions({ editar: "vehiculo", eliminar})}
                        />
                        <TableHeaderColumn
                            dataField="tipo_vehiculo"
                            dataSort
                            dataFormat={cell => cell.nombre}
                            width='20%'
                        >
                            VEHÍCULO
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataField="placa"
                            dataSort
                            width='20%'
                            dataFormat={(cell, row) => `${row.tipo_vehiculo.prefijo_placa || ''} ${cell}`}
                        >
                            PLACA
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataAlign="left"
                            dataField="id"
                            width='20%'
                            dataSort
                        >
                            CÓDIGO
                        </TableHeaderColumn>
                        <TableHeaderColumn width='20%'/>
                    </Grid>
                </Card>
            </div>
        )
    }
}
